



















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import PanelContent from '@/components/atoms/PanelContent.vue';
import ProductMenuLinks from '@/components/molecules/ProductMenuLinks.vue';
import { i18n } from '@/plugins/i18n/i18n';
import { ClickProductUrlEvent, ProductMenu } from '@/types/type';

@Component({
  components: { ProductMenuLinks, PanelContent },
})
export default class PortalHistoryMenusPanel extends Vue {
  private icon: string = 'history';
  private title: string = i18n.tc('portal.history');

  @Prop()
  private menus!: ProductMenu[];

  @Emit('history-menu-opened')
  private linkOpened(event: ClickProductUrlEvent): ClickProductUrlEvent {
    return event;
  }
}
